<template lang="pug">
  .module__main
    .module-content__container
      .add-user__btn
        el-button(type="primary" @click="activateAddUser()") Добавить
      .table__container
        .table-list__container
          el-table(
            v-loading="isLoading"
            :data="blackListUsers.list"
            style="width: 100%; font-size: 12px"
          )
            el-table-column(prop="value" label="Пользователь" width="200")
            el-table-column(prop="note" label="Примечание" width="200")
            el-table-column(prop="created" label="Добавлен" width="200")
            el-table-column(prop="added_by" label="Инициатор" width="200")
            el-table-column(label="Действия")
              template(slot-scope="scope")
                el-button(size="mini"  type="danger" @click="startDeleteUser(scope.row.value)").action__btn Удалить
          el-dialog(
            :visible.sync="isUserAddingActive"
            :before-close="resetUserAdding"
            title="Добавление пользователя"
            width="30%"
          )
            .h3 Введите данные
            .exchange-finish__container
              .exchange-finish__input
                el-input(v-model="addingUser.value" placeholder="Имя пользователя")
              .exchange-finish__input
                el-input(v-model="addingUser.note" placeholder="Примечание")
              .exchange-finish__buttons
                el-button(type="success" @click="startAddUser()") Добавить
                el-button(type="danger" @click="resetUserAdding()") Отменить
          el-pagination(
            style="margin-top: 20px"
            v-if='hasPagination',
            :total='blackListUsers.pagination.count',
            :page-size="per_page",
            :current-page='blackListUsers.pagination.page',
            background,
            layout='prev, pager, next',
            @current-change='loadBlackList'
          )
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { ADD_BLACK_LIST_USER, DELETE_BLACK_LIST_USER, LOAD_BLACK_LIST_USERS } from '../../store/const/exchange';

export default {
  name: 'BlackList',
  data() {
    return {
      page: 1,
      per_page: 50,
      isUserAddingActive: false,
      addingUser: {
        value: '',
        note: '',
      },
    };
  },
  mounted() {
    this.loadBlackList();
  },
  computed: {
    ...mapGetters(['loading']),
    ...mapGetters('exchange', {
      blackListUsers: 'blackListUsers',
    }),
    isLoading() {
      return this.isCategoryChanged && this.loading(LOAD_BLACK_LIST_USERS) === 'loading';
    },
    hasPagination() {
      let count = this.blackListUsers.pagination.count / this.blackListUsers.pagination.per_page;
      return this.blackListUsers.pagination.count && count > 1;
    },
  },
  methods: {
    ...mapActions('exchange', {
      loadList: LOAD_BLACK_LIST_USERS,
      addUser: ADD_BLACK_LIST_USER,
      deleteUser: DELETE_BLACK_LIST_USER,
    }),
    async loadBlackList(page = 1) {
      await this.loadList({
        params: {
          page,
          per_page: this.per_page,
        },
      });
      this.page = page;
    },
    async activateAddUser() {
      this.isUserAddingActive = true;
    },
    async startAddUser() {
      this.$confirm(
        `Вы уверены, что хотите добавить пользователя ${this.addingUser.value} в черный список?`,
        'Подтверждение',
      )
        .then(async () => {
          const request = await this.addUser(this.addingUser);
          console.log('Current request: ', request);
          if (request.success) {
            this.$message.success('Пользователь успешно добавлен');
            this.resetUserAdding();
            await this.loadBlackList(this.page);
          } else {
            this.$message.error(`Ошибка: ${request.message || 'Неизвестная ошибка'}`);
          }
        })
        .catch(() => {
          this.$message.info('Добавление отменено');
        });
    },
    async startDeleteUser(user) {
      this.$confirm(`Вы уверены, что хотите удалить пользователя ${user} из черного списка?`, 'Подтверждение')
        .then(async () => {
          const request = await this.deleteUser(user);
          if (request.success) {
            this.$message.success('Пользователь успешно удален');
            await this.loadBlackList(this.page);
          } else {
            this.$message.error(`Ошибка: ${request.message || 'Неизвестная ошибка'}`);
          }
        })
        .catch(() => {
          this.$message.info('Удаление отменено');
        });
    },
    resetUserAdding() {
      this.addingUser.value = '';
      this.addingUser.note = '';
      this.isUserAddingActive = false;
    },
  },
};
</script>
<style>
.add-user__btn {
  margin-bottom: 10px;
}
</style>
